import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
} from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";
import { useEffect } from "react";
import { useAuth } from "./contexts/AuthContext";
import { useToast } from "./contexts/ToastContext";
import { setAxiosHandlers } from "./services/axiosHandlers";

function AppContent() {
  const { logout } = useAuth();
  const { showWarningToast } = useToast();
  const navigate = useNavigate();

  useEffect(() => {
    setAxiosHandlers({
      logout,
      showWarningToast,
      navigate,
    });
  }, [logout, showWarningToast, navigate]);

  return <AppRoutes />;
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
